export default __webpack_public_path__ + "static/shape_square-045e8b2e2c76bdc16e70fc360017b660.png";